// src/pages/CollectionOrders/components/tables/CollectionOrderDataTable.tsx
import React from 'react';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { CollectionOrderDataForm, CollectionOrderFilters } from '../../../../app/models/CollectionOrder';
import useCollectionOrderService from '../../../../app/services/hooks/useCollectionOrderService';
import CollectionOrderFilter from './CollectionOrderFilter';

interface Props {
  items: CollectionOrderDataForm[];
  totalRows: number;
  loading?: boolean;
  edit?: (id: number) => void;
  show?: (id: number) => void;   // ya lo tenías
  destroy?: (id: number) => void;
  filter: CollectionOrderFilters;
  setFilter: (filter: CollectionOrderFilters) => void;
  callbackSuccess: () => void;
}

const ActiveToggle: React.FC<{ id: number; value?: boolean; onDone: () => void }> = ({ id, value, onDone }) => {
  const { activeCollectionOrder } = useCollectionOrderService();
  return (
    <input
      type="checkbox"
      checked={!!value}
      onChange={(e) => {
        activeCollectionOrder(id, e.target.checked, {
          onSuccess: () => onDone(),
          onError: () => onDone()
        });
      }}
    />
  );
};

const CollectionOrderDataTable = ({
  items, totalRows, loading = false, edit, show, destroy, filter, setFilter, callbackSuccess
}: Props) => {
  const columns = [
    {
      name: 'Id',
      selector: (row: any) => row.id,
      sortable: true,
      sortField: 'id',
      cell: (row: CollectionOrderDataForm) => <span>{row.id}</span>
    },

    {
      name: 'Sociedad',
      selector: (row: CollectionOrderDataForm) => row.society || '',
      sortable: true,
      sortField: 'society__name',
      cell: (row: CollectionOrderDataForm) => <span>{row.society || 'N/A'}</span>
    },

    {
      name: 'Proyecto',
      selector: (row: any) => row.project,
      sortable: true,
      sortField: 'project__name',
      cell: (row: CollectionOrderDataForm) => <span>{row.project}</span>
    },
    {
      name: 'Fecha programa',
      selector: (row: any) => row.program_date ?? '',
      sortable: true,
      sortField: 'program_date',
      cell: (row: CollectionOrderDataForm) => <span>{row.program_date ?? '—'}</span>
    },
    {
      name: 'Inicio',
      selector: (row: any) => row.start_date ?? '',
      sortable: true,
      sortField: 'start_date',
      cell: (row: CollectionOrderDataForm) => <span>{row.start_date ?? '—'}</span>
    },

    {
      name: 'Estado',
      selector: (row: any) => row.status_label ?? row.status,
      sortable: true,
      sortField: 'status',
      cell: (row: CollectionOrderDataForm) => <span>{row.status_label ?? row.status}</span>
    },
    
    {
      name: 'Acciones',
      selector: (row: any) => row.id,
      sortable: false,
      cell: (row: CollectionOrderDataForm) => (
        <div>
          {show && (
            <ButtonTableAction
              callbackFunction={() => show(row.id ?? -1)}
              classIcon="mdi mdi-eye"
              colorIcon="text-info"
              title="Ver"
            />
          )}
          {edit && (
            <ButtonTableAction
              callbackFunction={() => edit(row.id ?? -1)}
              classIcon="mdi mdi-pencil"
              colorIcon="text-warning"
              title="Editar"
            />
          )}
          {destroy && (
            <ButtonTableAction
              callbackFunction={() => destroy(row.id ?? -1)}
              classIcon="mdi mdi-delete"
              colorIcon="text-danger"
              title="Eliminar"
            />
          )}
        </div>
      )
    }
  ];

  return (
    <>
      <div className="row mt-3">
        <div className="col">
          <CollectionOrderFilter
            filter={filter}
            setFilter={setFilter}
            onSearch={callbackSuccess}
          />
        </div>
      </div>
      <DefaultDataTable
        columns={columns}
        data={items}
        progressPending={loading}
        paginationTotalRows={totalRows}
        filter={filter}
        setFilter={setFilter}
      />
    </>
  );
};

export default CollectionOrderDataTable;
